// extracted by mini-css-extract-plugin
export default {"container":"styles_container__osfEP","companyName":"styles_companyName__8JcOU","reportName":"styles_reportName__vZp5G"};